import axios from "../../axios";
const urlGetAllLevels = "/grammar-blogs";

const state = {
  list: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};

const actions = {
  async getList({ commit }, payload) {
    const response = await axios.get(urlGetAllLevels, { params: payload });
    if (response.status === 200) {
      commit("SET_GRAMMAR_BLOGS", response.data.data);
    }
    return response;
  },

  async create({ commit }, payload) {
    const response = await axios.post(urlGetAllLevels, payload);
    if (response.status === 200) {
      commit("CREATE_GRAMMAR_BLOGS", response.data.data);
    }
    return response;
  },

  async update({ commit }, { id, payload }) {
    const response = await axios.put(urlGetAllLevels + "/" + id, payload);
    if (response.status === 200) {
      commit("UPDATE_GRAMMAR_BLOGS", response.data.data);
    }
    return response;
  },

  async delete({ commit }, id) {
    const response = await axios.delete(urlGetAllLevels + "/" + id);
    if (response.status === 200) {
      commit("DELETE_GRAMMAR_BLOGS", response.data.data);
    }
    return response;
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_GRAMMAR_BLOGS(state, data) {
    state.list = data.data;
    state.pagination = data.pagination;
  },

  CREATE_GRAMMAR_BLOGS(state, data) {
    state.list.push(data);
  },

  UPDATE_GRAMMAR_BLOGS(state, data) {
    const index = state.list.findIndex((u) => u.id === data.id);
    if (index >= 0) {
      state.list.splice(index, 1, data);
    }
  },

  DELETE_GRAMMAR_BLOGS(state, itemId) {
    const index = state.list.findIndex((u) => u.id === itemId);
    if (index) {
      state.list.splice(index, 1);
    }
  },

  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },

  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
